<template>
	<b-modal
		ref="modal-changePlatform"
		id="change-sass-modal"
		hide-footer
		hide-header
		centered
		size="md"
		content-class="platform-modal"
	>
		<!-- Header -->
		<div class="text-center mb-4">
			<div class="platform-icon mb-3">
				<md-icon icon="swap_horiz" class="icon-lg"/>
			</div>
			<h4 class="mb-1">Cambiar de plataforma</h4>
			<p class="text-muted small mb-0">Selecciona el sistema al que deseas acceder</p>
		</div>

		<!-- Alert for single system -->
		<b-alert v-if="countAll === 1" show variant="warning" class="text-center">
			<md-icon icon="info" class="mr-1"/>
			Su usuario pertenece únicamente a este sistema.
		</b-alert>

		<!-- Selects view (10+ options) -->
		<b-form v-if="countAll >= 10" @submit="doChangePlatform">
			<b-form-group label="Tipo de sistema" label-class="font-weight-bold" class="mb-3">
				<multiselect
					v-model="sassSelectedOption"
					:options="typeOptions"
					:searchable="false"
					:close-on-select="true"
					:show-labels="false"
					:placeholder="$t('global.selectOption')"
					label="text"
					track-by="value"
					:allow-empty="false"
					@input="onTypeChange"
				/>
			</b-form-group>

			<b-form-group label="Sistema" label-class="font-weight-bold" class="mb-4">
				<multiselect
					v-model="sassReferenceOption"
					:options="sassOpts"
					:searchable="true"
					:close-on-select="true"
					:show-labels="false"
					:placeholder="$t('global.selectOption')"
					label="text"
					track-by="value"
					:allow-empty="false"
					:disabled="!sassSelectedOption"
				>
					<template #noResult>
						<span>No se encontraron resultados</span>
					</template>
				</multiselect>
			</b-form-group>

			<b-button
				variant="primary"
				block
				type="submit"
				class="py-2"
				:disabled="!sassReferenceOption"
			>
				{{ $t('global.change') }}
			</b-button>
		</b-form>

		<!-- Buttons view (2-9 options) -->
		<div v-if="countAll > 1 && countAll < 10">
			<!-- POS Section -->
			<div v-if="loadPos && $root.auxVars.userPointOfSalesAccess.length > 0" class="platform-section">
				<div class="section-header">
					<md-icon icon="store" class="section-icon text-info"/>
					<span class="section-title">Puntos de venta</span>
				</div>
				<div class="platform-buttons">
					<b-button
						v-for="(item, i) in $root.auxVars.userPointOfSalesAccess"
						:key="'pos-' + i"
						variant="outline-info"
						class="platform-btn"
						v-b-tooltip.hover
						title="Clic para cambiar a este punto de venta"
						@click="goToPlatform('pos', item.value)"
					>
						<md-icon icon="store" class="btn-icon"/>
						{{ item.text }}
					</b-button>
				</div>
			</div>

			<!-- Divider -->
			<hr v-if="loadPos && loadSuppliers && supplier.length > 0" class="my-4">

			<!-- Suppliers Section -->
			<div v-if="loadSuppliers && supplier.length > 0" class="platform-section">
				<div class="section-header">
					<md-icon icon="business" class="section-icon text-warning"/>
					<span class="section-title">Proveedores</span>
				</div>
				<div class="platform-buttons">
					<b-button
						v-for="(item, i) in supplier"
						:key="'sup-' + i"
						variant="outline-warning"
						class="platform-btn"
						v-b-tooltip.hover
						title="Clic para cambiar a este proveedor"
						@click="goToPlatform('supplier', item.value)"
					>
						<md-icon icon="business" class="btn-icon"/>
						{{ item.text }}
					</b-button>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import chatProvider from "@/components/helpers/helpers-chat";
import Multiselect from 'vue-multiselect';

export default {
	components: {
		Multiselect
	},
	data() {
		return {
			isActive: false,
			sassReferenceOption: null,
			sassSelectedOption: null,
			sassOpts: [],
			supplier: [],
		}
	},
	computed: {
		sassReferenceId() {
			return this.sassReferenceOption ? this.sassReferenceOption.value : null;
		},
		sassSelected() {
			return this.sassSelectedOption ? this.sassSelectedOption.value : null;
		},
		typeOptions() {
			const options = [];
			if (this.loadSuppliers) {
				options.push({ value: 'supplier', text: this.$t('global.supplier') });
			}
			if (this.loadPos) {
				options.push({ value: 'pos', text: this.$t('global.pointOfSale') });
			}
			return options;
		},
		countAll() {
			let pos = this.$root.auxVars.userPointOfSalesAccess;
			let sup = this.$root.auxVars.userSuppliersAccess;

			let total = 0;
			if (typeof pos != 'undefined')
				total = parseInt(pos.length) + parseInt(sup.length);
			else
				total = parseInt(sup.length);

			return total;
		},
		loadSuppliers() {
			return typeof this.$root.auxVars.userSuppliersAccess != 'undefined';
		},
		loadPos() {
			return typeof this.$root.auxVars.userPointOfSalesAccess != 'undefined';
		}
	},
	methods: {
		loadModel() {
			this.supplier = this.$root.auxVars.userSuppliersAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id);
			this.sassSelectedOption = null;
			this.sassReferenceOption = null;
			this.sassOpts = [];
			this.$refs["modal-changePlatform"].show();
		},

		onTypeChange(selected) {
			this.sassReferenceOption = null;
			if (selected && selected.value === 'supplier') {
				this.sassOpts = this.$root.auxVars.userSuppliersAccess.filter(item => item.value !== this.$root.store.state.currentSystem.system.id);
			} else if (selected && selected.value === 'pos') {
				this.sassOpts = this.$root.auxVars.userPointOfSalesAccess;
			} else {
				this.sassOpts = [];
			}
		},

		_process(type, referenceId) {
			this.$root.showWarning({
				message: 'Esta seguro de que desea cambiar de sistema?',
				okAction: (event, setLoading, close) => {
					setLoading(true)

					switch (type) {
						case 'supplier':
							this.$root.api.post('/auth/system', null, {
								headers: {
									"X-SC-TYPE": 'supplier',
									"X-SC-SYSTEM": referenceId,
								}
							}).then((response) => {
								this.$root.store.setSystemData(response.data)

								if(this.$route.path === '/')
									location.reload()
								else
									this.$router.push('/')

								setLoading(false)
							}).catch((err) => {
								this.$root.handleRequestError(err)
								close()
							})
							break;
						case 'pos':
							window.location = process.env.VUE_APP_POS + '/login?referenceId=' + referenceId + '&token=' + this.$root.store.state.currentToken
							setLoading(false)
							this.$root.auxVars.clearResources();
							this.$root.store.clearUser();
							if (this.$root.chatStarted) {
								chatProvider.shutdown();
								this.$root.chatStarted = false;
							}
							break;
						default:
							this.$root.showAlert('Seleccione un sistema valido', {variant: 'danger'})
							break;
					}
				}
			})
		},

		// event for select view
		doChangePlatform(evt) {
			evt.preventDefault();
			this._process(this.sassSelected, this.sassReferenceId)
		},

		// event for btns view
		goToPlatform(type, reference) {
			this._process(type, reference)
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({ vm: this, resourceNames: ['userListSassAccess'] });
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.platform-icon {
	width: 70px;
	height: 70px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border-radius: 50%;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.platform-icon .icon-lg {
	font-size: 32px;
	color: white;
}

::v-deep .platform-modal {
	border-radius: 12px;
	padding: 1.5rem;
}

.platform-section {
	margin-bottom: 1rem;
}

.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 0.75rem;
}

.section-icon {
	font-size: 20px;
	margin-right: 0.5rem;
}

.section-title {
	font-weight: 600;
	font-size: 1rem;
	color: #495057;
}

.platform-buttons {
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
}

.platform-btn {
	display: inline-flex;
	align-items: center;
	padding: 0.5rem 1rem;
	border-radius: 8px;
	font-weight: 500;
	transition: all 0.2s ease;
}

.platform-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.platform-btn .btn-icon {
	font-size: 16px;
	margin-right: 0.4rem;
}

::v-deep .multiselect__tags {
	border-radius: 8px;
	border: 1px solid #ced4da;
	padding: 10px 40px 10px 12px;
	min-height: 46px;
}

::v-deep .multiselect__single {
	margin-bottom: 0;
	padding: 0;
}

::v-deep .multiselect__placeholder {
	margin-bottom: 0;
	padding: 0;
	color: #6c757d;
}

::v-deep .multiselect__option--highlight {
	background: #667eea;
}

::v-deep .multiselect__option--selected.multiselect__option--highlight {
	background: #764ba2;
}

::v-deep .multiselect--disabled .multiselect__tags {
	background: #f8f9fa;
}
</style>











